import React, { useContext } from 'react';
import { AppDataContext } from '../../../contexts/appData';
import { HistoryContext } from '../../../contexts/history';
import { useMediaQuery, usePreventBodyScroll } from '../../../libs';
import { useCountDown } from '../../../libs/hooks/useCountDown';
import { PromData } from '../../../modules/header/components/PromData';

const FlashSalesModal = ({ callback, data, ...props }) => {
  const { langs, getLang } = useContext(AppDataContext);
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { push } = useContext(HistoryContext);
  usePreventBodyScroll();

  const flashSaleData = data?.flashSaleData
  const { timeLeft } = useCountDown({ endDate: flashSaleData?.end_date || ''});

  if (!flashSaleData) return null;

  const isExpired = timeLeft.days < 0 || timeLeft.hours < 0 || timeLeft.minutes < 0 || timeLeft.seconds < 0;

  const timeArr = isExpired ? ['00', '00', '00', '00'] : [
    String(timeLeft.days).padStart(2, '0'),
    String(timeLeft.hours).padStart(2, '0'),
    String(timeLeft.minutes).padStart(2, '0'),
    String(timeLeft.seconds).padStart(2, '0'),
  ];

  const onAgree = () => {
    push(`/${getLang}/myproducts`, {
      promID: activePromotion?.id,
      productID: flashSaleData?.product_id,
    });
    callback(null, 'onAgree');
    callback(null, 'destroy');
  };


  const activePromotion = PromData.find((item) => item.id === Number(flashSaleData?.offer_type));

  return (
    <div
      className="content-scroll"
      style={{ height: 'fit-content', background: 'white', maxWidth: isMobile ? '100%' : '80%', margin: '0 auto', position: 'relative', overflow: 'visible', paddingBottom: '20px', marginBottom: isMobile ? '60px' : 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <div
        style={{
          position: 'absolute',
          width: isMobile ? '64px' : '80px',
          height: isMobile ? '64px' : '80px',
          background: activePromotion?.bgColor,
          left: '50%',
          top: '-60px',
          borderRadius: '24px',
          transform: 'translateX(-50%)',
          zIndex: 20,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: `0 1px 14px 0 ${activePromotion?.bgColor}`
        }}
      >
        <i className={`svg-i ${activePromotion?.iconName}`} style={{width: '48px', height: '48px'}}></i>
      </div>
      <div className={'font-medium'} style={{ color: '#757B8C', fontSize: '14px', marginTop: '40px' }}>
        {activePromotion?.name}
      </div>
      <div className={'font-bold'} style={{ fontSize: '24px', textAlign: 'center' }}>
        მიიღე {flashSaleData?.discount_value}%-იანი ფასდაკლება
      </div>
      <div className={'font-base'} style={{ fontSize: '14px', textAlign: 'center', marginTop: '12px' }}>
        მიიღე {activePromotion?.name} ფასდაკლება და აქციე შენი{' '}
        <span style={{ textDecoration: 'underline', color: '#006aff', cursor: 'pointer' }} onClick={() => window.open(`/${getLang}/pr/${flashSaleData?.product_id}`, '_blank')}>{flashSaleData.title}</span> განცხადება უფრო ხილვადი და გამორჩეული.
      </div>
      <div
        style={{
          width: '100%',
          background: '#F4F4F5',
          padding: '24px 0',
          marginTop: '24px',
          borderRadius: '16px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div className={'font-base'} style={{ fontSize: '14px', color: '#222' }}>
          შეთავაზების დასრულებამდე დარჩენილია
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginTop: '16px' }}>
          {timeArr.map((item, index) => (
            <React.Fragment key={index}>
              <div
                style={{
                  background: 'white',
                  width: '45px',
                  height: '47px',
                  display: 'flex',
                  borderRadius: '4px',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <span className={'font-medium'} style={{ fontSize: '20px', color: '#222' }}>
                  {item}
                </span>
              </div>
              {index < timeArr.length - 1 && (
                <span className={'font-medium'} style={{ fontSize: '20px', color: '#222' }}>
                  :
                </span>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
      <button
        className="btn d-inline-flex align-items-center h-48px border-radius font-size-14 py-15px bg-primary font-medium"
        style={{ color: '#222', transition: 'all 0.3s ease', width: '100%', justifyContent: 'center', marginTop: '40px' }}
        onClick={onAgree}
      >
        გააქტიურება
      </button>
    </div>
  );
};

export default FlashSalesModal;
